"use client";

import { useCallback, useEffect, useState } from "react";
import {
  AvatarChange,
  InfoPribadiAlamat,
  InfoAkunPengiriman
} from "./_component";
import Label from "@/components/sub-atom/Label";
import useHeader from "@/functions/useHeader";
import Coordinates from "./_component/Coordinates";

export default function ProfileSaya() {
  const { session, profile } = useHeader();
  const {
    // event  personal
    username, // nama pemilik toko
    date_of_birth, // format yyyy-MM-dd
    telephone, // telephone pemilik toko wajib menggunakan 62
    gender, // format = L : laki-laki P : Perempuan
    // event account
    email,
    password,
    // event shipping
    name_store, // nama toko
    telephone_store, // telephone toko wajib menggunakan 62
    // event address
    address_information
  } = profile || {};
  const [forms, setForms] = useState({
    username,
    date_of_birth,
    telephone,
    gender: gender && {
      id: gender,
      title: gender == "L" ? "Laki-Laki" : "Perempuan"
    },
    address: address_information?.address,
    email,
    password,
    name_store,
    telephone_store
  });

  const [errors, setErrors] = useState({});

  const handleChange = (name) => (value) => {
    if (
      (name == "telephone" || name == "telephone_store") &&
      (value.startsWith("0") || value.startsWith("62"))
    ) {
      value = "+62" + value.slice(2);
    }
    setForms((form) => ({
      ...form,
      [name]: value
    }));
  };

  const handleChangeError = (name) => (value) => {
    setErrors((error) => ({
      ...error,
      [name]: value
    }));
  };

  return (
    <div className="flex flex-col gap-4">
      <AvatarChange forms={forms} profile={profile} errors={errors} />
      {(!profile?.telephone ||
        !profile?.telephone_store ||
        !profile?.gender ||
        !profile?.date_of_birth ||
        !profile?.address_information?.postal_code) && (
        <div className="flex flex-wrap flex-row gap-3 items-center">
          {(!profile?.telephone ||
            !profile?.gender ||
            !profile?.date_of_birth) && (
            <Label
              title={"*Info Pribadi"}
              className={"flex w-fit justify-center"}
              colors="error"
            />
          )}
          {!profile?.address_information?.postal_code && (
            <Label
              title={"*Info Alamat"}
              className={"flex w-fit justify-center"}
              colors="error"
            />
          )}
          {!profile?.telephone_store && profile?.mitra_level < 5 && (
            <Label
              title={"*Info Pengiriman"}
              className={"flex w-fit justify-center"}
              colors="error"
            />
          )}
        </div>
      )}
      <InfoPribadiAlamat
        handleChange={handleChange}
        handleChangeError={handleChangeError}
        forms={forms}
        setForms={setForms}
        profile={profile}
        errors={errors}
        setErrors={setErrors}
        token={session?.user?.token}
      />
      <InfoAkunPengiriman
        handleChange={handleChange}
        handleChangeError={handleChangeError}
        forms={forms}
        setForms={setForms}
        profile={profile}
        errors={errors}
        setErrors={setErrors}
        token={session?.user?.token}
      />
      {profile?.mitra_level == 1 && <Coordinates />}
    </div>
  );
}
